import { ApiDatafanPipeline, IApiDatafanPipelineExportUrl } from "@smp/api";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "datafan.pipeline.export.url";

export const useQueryDatafanExportUrlGet = (
  exportId: number | undefined,
  queryOptions?: UseQueryOptions<IApiDatafanPipelineExportUrl, unknown, string>,
) =>
  useQuery<IApiDatafanPipelineExportUrl, unknown, string>(
    [KEY, exportId],
    () =>
      ApiDatafanPipeline.Export.getUrl({
        path: { id: exportId || 0 },
      }),
    {
      ...queryOptions,
      enabled:
        !!exportId &&
        (queryOptions?.enabled || queryOptions?.enabled === undefined),
      select: (data) => data.url,
    },
  );

useQueryDatafanExportUrlGet.KEY = KEY;
